<template>
  <div >
    <v-row class="stepper-header">
      <v-col
        class="arrow py-2"
        cols="12"
        md="3">
        <strong class="header_text">{{ $t('modules.portalalumno.payments.paymentsStudents.view.banners.lastPayments')
          }}</strong>
      </v-col>
      <v-col class="payment_details py-2" cols="12" md="6">
        <p><strong>{{ lastPayment?.amount  | $currency }}</strong></p>
        <p>{{ lastPayment?.description }} | {{ lastPayment?.term}}</p>
      </v-col>
      <v-col cols="12" md="3" class="view_payments py-2" @click="goToHistoryPayments">
        <span class="text-decoration-underline cursor-pointer">
          {{ $t('modules.portalalumno.payments.paymentsStudents.view.banners.seeMyPayments') }}
        </span>
      </v-col>

    </v-row>

  </div>
</template>

<script>
export default {
  name: 'PaymentsHeader',
  props:{
    lastPayment:{type: Object}
  },
  methods: {
    goToHistoryPayments() {
      if (this.$isIPP)this.$router.push('/payments/history')
      if (this.$isMexico)this.$router.push('/payments/checking-account')
      this.$trackEvent('Pago', 'Clk_BtnVerPag_Pagos', 'PagosHistoricos') //Google Analytics - ver mis pagos IPP
    },
  }
}
</script>
<style scoped>
.stepper-header {
  font-family: 'DM Sans';
  font-size: 14px;
  box-shadow: none;
  overflow: hidden;
  height: auto;
  border-radius: 6px;
  background-color: var(--v-primary-lighten5);
  border: 1px solid #0050FE;
}

.payment_details {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.payment_details p {
  margin-bottom: 0;
}

.view_payments {
  padding-top: 13px;
  color: #0050FE;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.header-text {
  margin: 0;
  align-items: center;
}

.arrow {
  position: relative;
  display: inline-block;
  width: 33px;
  height: auto;
  padding: 5px 12px;
}

.arrow::before,
.arrow::after {
  content: "";
  position: absolute;
  top: calc(50% - 0.5px);
  right: 0;
  width: 45px;
  height: 1px;
  border-radius: 9999px;
  background-color: #0050FE;
  transform-origin: calc(100% - 0.5px) 50%;
}

.arrow::before {
  transform: rotate(45deg);
}

.arrow::after {
  transform: rotate(-45deg);
}
</style>
